interface DisposableAssistantConversationStore {
  dispose: () => void;
}

type ScheduleDisposal = (callback: () => void) => void;

const scheduleDeferredDisposal: ScheduleDisposal = callback => {
  setTimeout(callback, 0);
};

/**
 * Defers provider-unmount disposal long enough for React Strict Mode to replay
 * the effect setup and retain the still-mounted store.
 */
export const createAssistantConversationLifecycle = (schedule: ScheduleDisposal = scheduleDeferredDisposal) => {
  let retentionGeneration = 0;

  return {
    retain: () => {
      retentionGeneration += 1;
    },
    release: (store: DisposableAssistantConversationStore | null) => {
      const releaseGeneration = retentionGeneration;
      schedule(() => {
        if (releaseGeneration === retentionGeneration) {
          store?.dispose();
        }
      });
    },
  };
};
